import React from 'react';
import Logo from '../assets/images/logo.png';
import { useNavigate, Link, NavLink } from 'react-router-dom';
import { LogoutSvg } from '../assets/images/Images';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';

const Header = ({ setToggle, toggle }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <header id="header" className="fixed-top">
      {/* <nav className="navbar-fixed-top navbar p-0 box-shadow" role="navigation"> */}
      {/* <div className="navbar-header">
          <button
            className="d-block d-sm-none"
            type="button"
            data-target="#aside"
            id="toggle_btn"
            onClick={() => {
              //setToggle(!toggle);
            }}
          >
            <i className="fa fa-align-left"></i>
          </button>
          <Link className="navbar-brand" to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div> */}
      <Navbar expand="lg">
        <Navbar.Brand to="/">
          <img src={Logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="m-auto my-2 my-lg-0 align-items-center"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            {/* <NavLink
              to="/user"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Users</span>
            </NavLink> */}

            <NavDropdown title="Users" id="navbarScrollingDropdown">
              <NavDropdown.Item
                as={NavLink}
                to="/user"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Users</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/live/users"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Live Users</span>
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Reports" id="navbarScrollingDropdown">
              <NavDropdown.Item
                as={NavLink}
                to="/history/call"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Call</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/history/sms"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>SMS</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/history/bundle"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Bundle</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/payment"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Payment</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/failed-payment"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Failed Payment</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/history/refund"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Refund</span>
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="DID Numbers" id="navbarScrollingDropdownDID">
              {/* <NavDropdown.Item>
                <NavLink
                  to="/numbers/DIDs"
                  className={({ isActive }) =>
                    isActive ? 'activeClassName' : undefined
                  }
                >
                  <span>Numbers</span>
                </NavLink>
              </NavDropdown.Item> */}
              <NavDropdown.Item
                as={NavLink}
                to="/numbers/bought"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Bought</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/numbers/ported"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Ported</span>
              </NavDropdown.Item>

              <NavDropdown.Item
                as={NavLink}
                to="/numbers/requested"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Requested</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/numbers/stock"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Number Stock</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/live/number"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Live VN Number</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/numbers/add-country"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Add DID Country</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/numbers/expired-vn"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Expired French VN</span>
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Bundles / Plans"
              id="navbarScrollingDropdownbundles"
            >
              <NavDropdown.Item
                as={NavLink}
                to="/bundle/call"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>CALL</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/bundle/sms"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>SMS</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/bundle/vn"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>VN</span>
              </NavDropdown.Item>
            </NavDropdown>

            {/* <NavLink
              to="/plans"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Plans</span>
            </NavLink> */}
            <NavLink
              to="/providers"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Providers</span>
            </NavLink>
            <NavDropdown title="Rates" id="navbarScrollingDropdownRates">
              <NavDropdown.Item
                as={NavLink}
                to="/rates/call"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>Call</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/rates/sms"
                className={({ isActive }) =>
                  isActive ? 'activeClassName' : undefined
                }
              >
                <span>SMS</span>
              </NavDropdown.Item>
            </NavDropdown>
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Settings</span>
            </NavLink>
            <NavLink
              to="/external-payment-list"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>External Payment List</span>
            </NavLink>
            <NavLink
              to="/re-route"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Re-Route</span>
            </NavLink>
            <NavLink
              to="/block-list"
              className={({ isActive }) =>
                isActive ? 'activeClassName' : undefined
              }
            >
              <span>Blocked Number</span>
            </NavLink>
          </Nav>
          <div className="d-flex">
            <Link className="user_img" onClick={() => handleLogout()} to="#">
              <span className="user_icon">
                <LogoutSvg />
              </span>

              <span className="user_name">&nbsp;Logout</span>
            </Link>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
